import { Link } from "react-router-dom";

const pages = [
  {
    title: "WHS™ shot allowances for each format",
    body: "Singles, fourball, foursomes, greensomes, scramble — every official allowance, side by side.",
    href: "/formats",
    icon: "ri-list-check-2",
  },
  {
    title: "How playing handicaps are calculated",
    body: "From Handicap Index to Course Handicap to Playing Handicap — explained simply.",
    href: "/how-it-works",
    icon: "ri-flow-chart",
  },
  {
    title: "Common WHS™ handicap questions",
    body: "Rounding rules, mixed tees, women vs men, par adjustments and more.",
    href: "/faq",
    icon: "ri-question-answer-line",
  },
];

export default function PopularPages() {
  return (
    <section className="bg-background-50 py-20 md:py-24">
      <div className="mx-auto max-w-content px-4 md:px-6">
        <h2 className="font-heading font-bold text-foreground-950 text-2xl md:text-3xl">
          <a href="#popular">Popular pages</a>
        </h2>
        <p className="mt-2 text-sm md:text-base text-foreground-700 max-w-xl">
          Quick reference resources from the HANDICALC® knowledge base.
        </p>

        <div className="mt-10 grid grid-cols-1 md:grid-cols-3 gap-5">
          {pages.map((p) => (
            <Link
              key={p.title}
              to={p.href}
              className="group rounded-xl bg-background-100 hover:bg-background-50 border border-background-200 hover:border-primary-300 p-6 transition-colors cursor-pointer flex flex-col"
            >
              <span className="w-11 h-11 flex items-center justify-center rounded-lg bg-background-50 text-primary-700 border border-background-200 group-hover:bg-primary-600 group-hover:text-background-50 transition-colors">
                <i className={`${p.icon} text-lg`}></i>
              </span>
              <h4 className="mt-5 font-heading font-semibold text-foreground-950 text-base md:text-lg">
                {p.title}
              </h4>
              <p className="mt-2 text-sm text-foreground-700 leading-relaxed flex-1">{p.body}</p>
              <span className="mt-4 inline-flex items-center gap-1 text-sm font-medium text-primary-700 whitespace-nowrap">
                Read more <i className="ri-arrow-right-line"></i>
              </span>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}